module.exports = __webpack_public_path__ + "img/horizontal_4_6_pp1_6000.04d36890.png";